import React, { useEffect, useState } from 'react'
import { Dropdown, Menu, Button } from 'antd'
import { HeaderStyle } from './style'
import { IMenuArray, IMenuItem } from 'model'
import { useNavigate } from 'react-router-dom'
import { setBreadcrumbState } from 'store/slice/title'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import { setUserInfoState, UserInfoState } from 'store/slice/userInfo'
import { apiLoginOut } from 'api'
import { setMenuListState } from 'store/slice/menuList'
import { DownOutlined } from '@ant-design/icons';
import { setButtonListState } from 'store/slice/buttonList'

interface Props {
  clickMenu?: (item: IMenuItem) => void
}

const HeadertPage = (props: Props) => {
  const navigate = useNavigate()
  const menuArray:IMenuArray = useSelector((state: RootState) => {
    return state.menuListSlice.menuList
  })

  const UserInfo:UserInfoState = useSelector((state: RootState) => {
    return state.userInfoSlice
  })
  const dispatch = useDispatch()
  let navigator = useNavigate()
  const [key , setKey] =  useState<string>('');
  const sessionkey = sessionStorage.getItem('key')
  useEffect(() => {
    if(!menuArray.length){
      navigate('/login');
      return;
    }
    if(sessionkey){
      setKey(sessionkey)
      for (const iterator of menuArray) {
        if(iterator.id === sessionkey){
          props.clickMenu(iterator)
        }
      }
    } else {
      setKey(menuArray[0].id)
      props.clickMenu(menuArray[0])
    }
  }, [])

  const loginOut = ()=>{
    try {
      apiLoginOut({}).then(res => {
        navigate('/login');
        sessionStorage.clear();
        localStorage.clear();
        dispatch(setMenuListState({ menuList: [] }));
        dispatch(setUserInfoState({realName: ''}));
        dispatch(setBreadcrumbState({}))
        dispatch(setButtonListState({ buttonList: [] }));
      })
    } catch (error) {
    }
  }

  const menu = (
    <Menu>
      <Menu.Item onClick={loginOut} key="0">
        退出登录
      </Menu.Item>
    </Menu>
  );

  const clickNav = (item:IMenuItem)=>{
    if(sessionkey === item.id){
      return;
    }
    let txt: string = '';
    txt = item.menuVOS[0].name + ' / ' + item.menuVOS[0].menuVOS[0].name
    dispatch(setBreadcrumbState({ title: item.name, menuName: txt}))
    sessionStorage.setItem('key', item.id);
    sessionStorage.setItem('selectedKeys', item.menuVOS[0].menuVOS[0].id);
    sessionStorage.setItem('openKeys', item.menuVOS[0].id);
    navigator(item.menuVOS[0].menuVOS[0].url)
    props.clickMenu(item)
  }
  return (
    <HeaderStyle>
      <div className="headerMain">
      {key ? (<Menu theme="dark" mode="horizontal" defaultSelectedKeys={[key]}>
        {menuArray.map((item) => {
          return (
            <Menu.Item key={item.id} onClick={()=>clickNav(item)}>{item.name}</Menu.Item>
          )
        })}
      </Menu>): ''}
      <Dropdown overlay={menu} placement="bottomRight" arrow>
        <div className="dropdownMain">{UserInfo.realName}<DownOutlined /></div>
      </Dropdown>
      </div>
    </HeaderStyle>
  )
}

export default HeadertPage;
